import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=50b3bafe&scoped=true&"
import script from "./goodsAdd.vue?vue&type=script&lang=js&"
export * from "./goodsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3bafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b3bafe')) {
      api.createRecord('50b3bafe', component.options)
    } else {
      api.reload('50b3bafe', component.options)
    }
    module.hot.accept("./goodsAdd.vue?vue&type=template&id=50b3bafe&scoped=true&", function () {
      api.rerender('50b3bafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/businessCooperation/components/goodsAdd.vue"
export default component.exports